module.exports = __webpack_public_path__ + "img/CM-KT-25-Cadillac-Established.0170ab6c.jpg";